import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserSelectors from "redux/modules/user/selectors";
import Reference from "./Reference";

const mapStateToProps = state => ({
  user: UserSelectors.user(state)
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Reference);
